export default __webpack_public_path__ + "static/media/Exam_session.6d500c72.svg";